import { useState, useRef } from "react";

export function useToast() {
  const [toast, setToast] = useState(null);
  const timerRef = useRef(null);
  const showToast = (message, type = "success", icon = "✓", persistent = false, subtext = null) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast({ message, type, icon, id: Date.now(), subtext });
    if (!persistent) {
      timerRef.current = setTimeout(() => setToast(null), 4000);
    }
  };
  const dismissToast = () => { setToast(null); if (timerRef.current) clearTimeout(timerRef.current); };
  return { toast, showToast, dismissToast };
}

export function useCopyToast() {
  const [copied, setCopied] = useState(false);
  const copy = async (text) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
      } else {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      console.error("Copy failed", e);
    }
  };
  return { copied, copy };
}
